import {useAuth0} from '@auth0/auth0-react';
import {
    faArrowRightFromBracket,
    faBuilding,
    faContactBook,
    faFileLines,
    faGear,
    faHouse,
    faUser,
    faListTree, faStar, faNewspaper
} from '@fortawesome/pro-light-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import logo from 'Assets/Images/logo.svg';
import {Link} from 'react-router-dom';
import Permissions from 'Services/Authentication/Permissions/Permissions.types';
import usePermissions from 'Services/Authentication/usePermissions';
import {ROUTES} from 'Services/Route/Route.types';
import styles from './Navigation.module.sass';
import {useVersion} from 'Services/VersionContext';
import {faCodeBranch, faEnvelope} from '@fortawesome/pro-thin-svg-icons';
import BlogMenuDropdown from '../../Atoms/BlogMenuDropdown/BlogMenuDropdown';

const menu = [{
    className: 'home', 
    path: ROUTES.DASHBOARD.path,
    icon: faHouse,
    title: 'Home',
}, {
    className: 'vacancies', 
    path: ROUTES.VACANCIES.path,
    icon: faFileLines,
    title: 'Vacatures',
}, {
    className: 'candidates', 
    path: ROUTES.CANDIDATES.path,
    icon: faUser,
    title: 'Kandidaten',
}, {
    className: 'candidates',
    path: ROUTES.OPTIONS.path,
    icon: faListTree,
    title: 'Shortlists',
}, {
    className: 'business_units', 
    path: ROUTES.BUSINESS_UNITS.path,
    icon: faBuilding,
    title: 'Bedrijven',
},
{
    className: 'offers',
    path: ROUTES.OFFERS.path,
    icon: faStar,
    title: 'Aanbiedingen',
},
{
    className: 'contacts', 
    path: ROUTES.CONTACTS.path,
    icon: faContactBook,
    title: 'Contactpersonen',
}, {
    className: 'blog',
    path: ROUTES.BLOG.path,
    icon: faNewspaper,
    title: 'Blog',
}, {
    className: 'mails',
    path: ROUTES.MAILS.getFullPath(),
    icon: faEnvelope,
    title: 'Mails',
    permission: Permissions.Mail.READ.ALL
}, {
    className: 'settings',
    path: ROUTES.SETTINGS.getFullPath(),
    icon: faGear,
    title: 'Instellingen'
}];

const Navigation = () => {
    const { version } = useVersion();
    const { user, logout } = useAuth0();
    const permissions = usePermissions();

    return <div className={styles['navigation__container']}>
        <div className={styles['navigation']}>
            <div className={styles['navigation__header']}>
                <img src={logo} alt='Logo' width={'118px'}/>
            </div>

            <div className={styles['navigation__menu']}>
                {
                    menu.map((menuItem: any) => {
                        if (menuItem?.permission && !permissions?.includes(menuItem.permission)) return <></>;

                        let isActive = false;
                        const isAtHomepage = window.location.pathname === '/' && menuItem.path === '/';
                        const startsWithPath = menuItem.path !== '/' && window.location.pathname.startsWith(menuItem.path);
                        if (isAtHomepage || startsWithPath) isActive = true;

                        return <Link
                            to={menuItem.path}
                            className={`${styles['navigation__menu-item']}
                            ${styles[`navigation__menu-item-${menuItem.className}`]}
                            ${styles['navigation__menu-item--'+(isActive ? 'active' : 'inactive')]}`}
                        >
                            <div className={styles['navigation__menu-item-icon']}>
                                <FontAwesomeIcon
                                    icon={menuItem.icon}
                                    size='lg'
                                />
                            </div>
                            <span>{menuItem.title}</span>
                        </Link>
                    })
                }
                
               
            </div>

            <div className={styles['navigation__footer']}>
                <div className={styles['navigation__footer-item']} style={{pointerEvents: 'none'}}>
                    <div className={styles['navigation__footer-item-icon']}>
                        <FontAwesomeIcon
                            icon={faCodeBranch}
                            size='lg'
                        />
                    </div>
                    <span>Versie {version}</span>
                </div>

                <Link
                    to={ROUTES.PROFILE.getFullPath()}
                    className={`${styles['navigation__footer-item']} ${styles['navigation__menu-item-home']} ${styles['navigation__menu-item--'+((window.location.pathname === ROUTES.PROFILE.getFullPath()) ? 'active' : 'inactive')]}`}
                >
                    <div className={styles['navigation__footer-item-icon']}>
                        <img src={user?.picture} alt="profile" width='80' />
                    </div>
                    <span>{ user?.name }</span>
                </Link>
                <div className={styles['navigation__footer-item']} onClick={() => logout({
                    returnTo: window.location.origin
                })}>
                    <div className={styles['navigation__footer-item-icon']}>
                        <FontAwesomeIcon
                            icon={faArrowRightFromBracket}
                            size='lg'
                        />
                    </div>
                    <span>Uitloggen</span>
                </div>
            </div>
        </div>
    </div>;
}

export default Navigation;